import { Button, Modal } from "react-bootstrap";
import Lottie from "lottie-react";
import animationData from '../assets/json/loading.json';
import "./loading.modal.scss";
interface LoadingProps {
    isOpen: boolean,
    onClose: () => void,
    message: string

}

const LoadingModal: React.FC<LoadingProps> = ({ isOpen, onClose, message }) => {

    return (
        <>
            <Modal centered show={isOpen} onHide={onClose}>
                <Modal.Body className="loadingControl">
                    <div className="bodyControl">
                        <Lottie animationData={animationData} className="icon" ></Lottie>
                        <span className="text">{message}</span>
                    </div>
                </Modal.Body>

            </Modal>

        </>
    )
}

export default LoadingModal;